import utils = egr.wcf.utils;

export function getFileExtension(value: string | undefined): string {
    if (utils.string.isNotNullOrEmpty(value)) {
        const splittedName: Array<string> = value.split('.');
        if (splittedName.length > 0) {
            return splittedName[splittedName.length - 1];
        }
    }
    return '';
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/String.ts